import React, { useRef } from 'react';
import {
    Row,
    Col,
    Divider,
    Typography,
    Statistic,
    Skeleton,
    Result,
    Button
} from 'antd';
import {
    PrinterOutlined
} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useReactToPrint } from 'react-to-print';
import { formatPhone } from '../../utils/customFunctions';
import TransactionItems from './components/TransactionItems';
import TransferDoc from '../../components/TransferDoc';

// const convertTransaction = (type) => {

//     switch (type) {
//         case 'IN': return 'ซื้อเข้า';
//         case 'OUT': return 'ขายออก';
//         case 'TRANSIN': return 'โอนเข้า';
//         case 'TRANSOUT': return 'โอนออก';
//         case 'ADJUST': return 'ปรับสต๊อก';
//         default: return 'ปรับสต๊อก';
//     }

// }

function Detail() {
    const { id } = useParams();
    const componentRef = useRef();
    const onPrint = useReactToPrint({
        content: () => componentRef.current
    });
    const { isError, isLoading, data, error } = useQuery({
        queryKey: [`/api/transaction/${id}`],
    })

    if (isLoading) {
        return <Skeleton active />
    }

    if (isError) {
        return <Result status="error" title={error.message} />
    };

    // console.log(data);
    return (
        <div style={{
            background: '#fff',
        }}>
            {data.transaction_type === 'TRANSOUT' && <Row justify="end">
                <Col>
                    <Button icon={<PrinterOutlined />} onClick={onPrint} >พิมพ์</Button>
                </Col>
            </Row>}
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    {data.transaction_type === 'TRANSOUT' ?
                        <Typography.Title level={3}>
                            รายระเอียดใบโอนสินค้า
                        </Typography.Title>
                        :
                        <Typography.Title level={3}>
                            รายระเอียดใบรับสินค้า
                        </Typography.Title>}
                    <Typography.Title level={5}>
                        {`เลขที่ ${data.doc_no}`}
                    </Typography.Title>
                </Col>
                <Divider />
                <Col xs={24}>
                    {data.transaction_type === 'TRANSOUT' ? <Row justify="space-between">
                        <Col xs={14}>
                            <Row>
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        สาขาที่รับโอน
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {data.customer.company}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        ที่อยู่
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {data.customer.address}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {`แขวง/ตำบล${data.customer.sub_district} อำเภอ${data.customer.district}`}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {`จังหวัด${data.customer.province} รหัสไปรษณีย์ ${data.customer.postalcode}`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col xs={8} >
                                    <Typography.Text strong>
                                        วันที่
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary">
                                        {dayjs(data.order_date).format('DD-MM-YYYY')}
                                    </Typography.Text>
                                </Col>
                            </Row> */}
                        </Col>
                        <Col xs={10}>
                            <Row justify="end">
                                <Col xs={16}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong >
                                                เลขที่
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                                {data.doc_no}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={16}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                วันที่
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                                {dayjs(data.order_date).format('DD-MM-YYYY')}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={16}>
                                    <Row justify='space-between'>
                                        <Col>
                                            <Typography.Text strong >
                                                พนักงาน
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                                {data.employee.fname}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                        :
                        <Row justify="space-between">
                            <Col xs={12}>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            ชื่อผู้ขาย
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {data.customer.company}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            ที่อยู่
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {data.customer.address}
                                        </Typography.Text>
                                        <br />
                                        <Typography.Text type="secondary">
                                            {`แขวง/ตำบล${data.customer.sub_district} อำเภอ${data.customer.district}`}
                                        </Typography.Text>
                                        <br />
                                        <Typography.Text type="secondary">
                                            {`จังหวัด${data.customer.province} รหัสไปรษณีย์ ${data.customer.postalcode}`}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            โทร.
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {formatPhone(data.customer.phone)}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            เลขที่ใบส่งของ
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {data.doc_ref}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            วันที่สั่งซื้อ
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {dayjs(data.order_date).format('DD-MM-YYYY')}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            วันที่รับของ
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {dayjs(data.shipment_date).format('DD-MM-YYYY')}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Typography.Text strong>
                                            ผู้รับของ
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <Typography.Text type="secondary">
                                            {data.employee.fname}
                                        </Typography.Text>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>}
                </Col>
                <Divider />
                <Col xs={24}>
                    <TransactionItems items={data.transaction_items} />
                </Col>
                <Col xs={24} style={{ marginTop: '24px' }}>
                    <Row justify='end'>
                        <Col>
                            <Typography.Paragraph
                                strong
                                style={{
                                    margin: '0px',
                                    fontSize: '16px'
                                }}
                            >
                                รวมทั้งสิ้น
                            </Typography.Paragraph>
                        </Col>
                        <Col>
                            <Statistic
                                value={data.transaction_items.reduce((prev, cur) => (cur.quantity * cur.price) + prev, 0)}
                                precision={2}
                                valueStyle={{ fontSize: 16, fontWeight: 600, margin: '0px 8px' }}
                            />
                        </Col>
                        <Col>
                            <Typography.Paragraph
                                strong
                                style={{
                                    margin: '0px',
                                    fontSize: '16px'
                                }}
                            >
                                บาท
                            </Typography.Paragraph>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div style={{ display: "none" }}>
                <TransferDoc docData={data} printRef={componentRef} />
            </div>
        </div>
    )
}

export default Detail